import React, { Component } from "react"
import { Modal } from "antd"

class AboutVideoModal extends Component {
	render() {
		// const {
		// 	// visible,
		// 	// onCancel,
		// 	// onCreate,
		// 	// formRef,
		// 	// onSignUpClick,
		// } = this.props
		return (
			<React.Fragment>
				<Modal
					className='login_block'
					visible={this.props.isOpen}
					okText='Recover'
					onOk={this.props.onCloseModal}
					onCancel={this.props.onCloseModal}
					footer={null}
				>
					<iframe
						title="about zimble"
						width='100%'
						height='315'
						src='https://www.youtube.com/embed/VGhwtJXWRcw'
						frameborder='0'
						allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
						allowfullscreen
					></iframe>
				</Modal>
			</React.Fragment>
		)
	}
}

export default AboutVideoModal
